export function isNaN(x) {
  typeof x === 'number' && isNaN(x);
}
